import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/Factors/Get`, payload),
    GetActive: (payload) => Repository.post(`/api/Factors/GetActive`, payload),
}
